// Formato de los valores de un reporte de BI → Reportes. Lo comparten la
// pantalla de la compu y la del celular: el reporte dice el FORMATO de cada
// columna/KPI ('pesos' | 'pct' | 'dia' | 'texto') y acá se dibuja igual en
// las dos.

const pesosFmt = new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
const pesosCortoFmt = new Intl.NumberFormat('es-AR', { maximumFractionDigits: 1 })

/** $ 12.710.608,27 */
export const fmtPesos = (v) => (v == null ? '—' : '$ ' + pesosFmt.format(v))

/** $ 12,7 M — para el celular, donde la cifra completa no entra. */
export function fmtPesosCorto(v) {
  if (v == null) return '—'
  const a = Math.abs(v)
  if (a >= 1e9) return '$ ' + pesosCortoFmt.format(v / 1e9) + ' mil M'
  if (a >= 1e6) return '$ ' + pesosCortoFmt.format(v / 1e6) + ' M'
  if (a >= 1e3) return '$ ' + pesosCortoFmt.format(v / 1e3) + ' mil'
  return '$ ' + pesosCortoFmt.format(v)
}

/** +35,4 % · −19,7 % */
export function fmtPct(v) {
  if (v == null || !isFinite(v)) return '—'
  const s = (Math.abs(v) * 100).toFixed(1).replace('.', ',')
  return (v >= 0 ? '+' : '−') + s + ' %'
}

const enteroFmt = new Intl.NumberFormat('es-AR', { maximumFractionDigits: 0 })

export function fmtValor(v, formato, { corto = false } = {}) {
  if (formato === 'pesos') return corto ? fmtPesosCorto(v) : fmtPesos(v)
  if (formato === 'entero') return v == null ? '—' : enteroFmt.format(v)
  if (formato === 'pct') return fmtPct(v)
  return v == null ? '—' : String(v)
}

/** Tono de una variación: verde si sube, rojo si baja. */
export const tonoDe = (v, formato) => (formato === 'pct' && v != null ? (v >= 0 ? 'pos' : 'neg') : null)
